import type { Cut } from '@/types/quiz'

/**
 * Customer quotes pulled from real NP reviews. One per question screen plus
 * one per recommended cut. Kept here as a single source of truth so copy
 * updates don't require touching the screen components.
 */

export interface Quote {
  text: string
  attribution: string
}

const q = (text: string, attribution: string): Quote => ({ text, attribution })

export const ACTIVITY_SCREEN_QUOTE: Quote = q(
  "All the features are well thought out and make my day so much easier.",
  'Julija',
)

export const PAIN_SCREEN_QUOTE: Quote = q(
  "I had given up on finding snow pants that would actually fit both my waist & hips, but these do! Amazing!",
  'Katrina',
)

export const SHAPE_SCREEN_QUOTE: Quote = q(
  "I really love the body size and shape inclusivity that is incorporated into the design!",
  'Mel',
)

export const HEIGHT_SCREEN_QUOTE: Quote = q(
  "These are the first pants in history to be THE perfect length!",
  'Merryn',
)

export const RESULT_QUOTES: Record<Cut, Quote> = {
  zali:     q("Simply amazing not to worry about my thighs or splitting ass due to my womanly shape.", 'Nicole'),
  mila:     q("My waist, hips and bottom are fitting like never before. Love all the adjustments!", 'Tere'),
  beatrice: q("They don't dig in where I don't want them to dig in, they stretch, they move, they just do the job they're supposed to do.", 'Mandy'),
}
